<template>
  <div>
    <div v-if="!loading">
      <div v-if="order" class="flex flex-col">
        <div class="card w-full">
          <div class="flex justify-between items-center">
            <p class="font-semibold">ID: #{{ order.id }}</p>
          </div>

          <div class="div-line"></div>

          <p
            v-if="order.status === 'pending'"
            class="p-1 text-xs bg-orange-500 w-fit rounded text-white"
          >
            Pendiente
          </p>

          <p
            v-else-if="order.status === 'completed'"
            class="p-1 text-xs bg-success-500 w-fit rounded text-white"
          >
            Completada
          </p>

          <div class="mt-2 text-sm">
            <p class="font-medium">Fecha de creación</p>
            <p>{{ formatDatetime(order.created_at) }}</p>
          </div>

          <div class="mt-2 text-sm">
            <p class="font-medium">Fecha de última actualización</p>
            <p>{{ formatDatetime(order.updated_at) }}</p>
          </div>

          <div class="mt-2 text-sm">
            <p class="font-medium">Sucursal</p>
            <router-link
              v-if="order.branch && order.branch.franchise"
              :to="{
                name: 'branchesDetail',
                params: {
                  franchiseId: order.branch.franchise.id,
                  id: order.branch.id,
                },
              }"
              class="underline system-button"
              >{{ order.branch.name }}</router-link
            >
            <span v-else class="text-content-300">B2C (no aplica)</span>
          </div>

          <div v-if="order.status === 'completed'">
            <div class="mt-2 text-sm">
              <p class="font-medium"># de guía</p>
              <p>{{ order.tracking_number }}</p>
            </div>

            <div class="mt-2 text-sm">
              <p class="font-medium">URL de rastreo</p>
              <p>{{ order.tracking_url }}</p>
            </div>
          </div>

          <div v-for="item in order.items" :key="item.id" class="flex mt-4">
            <img
              :src="getImage(item)"
              alt=""
              class="rounded-t-lg w-20 h-20 aspect-square object-contain object-center bg-white mr-4"
            />

            <div>
              <router-link
                :to="{
                  name: 'productsDetail',
                  params: { id: item.product.id },
                }"
                class="underline system-button"
                >{{ item.product.name }}</router-link
              >
              <p>
                Precio unitario:
                {{ integerToCurrency(item.product.unit_price) }}
              </p>
              <p>Cantidad: {{ item.quantity }}</p>
            </div>
          </div>

          <div class="flex justify-between mt-6">
            <p class="text-sm font-medium">Subtotal:</p>
            <p class="text-sm font-medium">
              {{ integerToCurrency(order.total - order.shipping_price) }}
            </p>
          </div>

          <div class="flex justify-between mt-2">
            <p class="text-sm font-medium">Precio de envío:</p>
            <p class="text-sm font-medium">
              {{ integerToCurrency(order.shipping_price) }}
            </p>
          </div>
          <div class="flex justify-between mt-2">
            <p class="text-sm font-semibold">Total:</p>
            <p class="text-sm font-semibold">
              {{ integerToCurrency(order.total) }}
            </p>
          </div>

          <div v-if="order.status === 'pending'" class="mt-6">
            <form @submit.prevent="send">
              <div class="flex flex-col w-full">
                <label for="tracking_number"># de guía</label>
                <input
                  id="tracking_number"
                  type="text"
                  v-model="form.tracking_number"
                />
                <validation-errors
                  :errors="errorFor('tracking_number')"
                ></validation-errors>
              </div>

              <div class="flex flex-col w-full mt-2">
                <label for="tracking_number">URL de rastreo</label>
                <input
                  id="tracking_url"
                  type="text"
                  v-model="form.tracking_url"
                />
                <validation-errors
                  :errors="errorFor('tracking_url')"
                ></validation-errors>
              </div>

              <primary-button
                class="mx-0 mt-8"
                :loading="loadingSend"
                type="submit"
                >Marcar como enviada</primary-button
              >
            </form>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="flex w-full h-full items-center">
      <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
    </div>
  </div>
</template>

<script>
import validationErrors from "@/mixins/validationErrors";
import { is422 } from "@/utils/response";
import api from "@/api";
import { formatDatetime } from "@/utils/dateFormatter";
import { integerToCurrency } from "@/utils/currencyFormatter";
export default {
  name: "Product Order Detail",

  data() {
    return {
      order: null,
      loading: false,
      loadingSend: false,
      defaultImage: require("@/assets/paw.png"),
      form: {
        tracking_number: "",
        tracking_url: "",
      },
    };
  },

  mixins: [validationErrors],

  created() {
    this.$store.commit("setSelectedTab", "productOrders");

    this.loadProductOrder();
  },

  methods: {
    formatDatetime,

    integerToCurrency,

    async loadProductOrder() {
      this.loading = true;

      try {
        this.order = await api.productOrders.getById(this.$route.params.id);
        this.$store.commit('setBreadcrumbLabel', {
          routeName: this.$route.name,
          label: 'Orden #' + this.order.id,
        });
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
        this.$router.push({ name: "productOrdersIndex" });
      }

      this.loading = false;
    },

    getImage(item) {
      if (!item.product.image_url) {
        return this.defaultImage;
      }

      return item.product.image_url;
    },

    validateForm() {
      this.errors = {};

      if (!this.form.tracking_number) {
        this.errors["tracking_number"] = ["Campo requerido"];
      }

      if (!this.form.tracking_url) {
        this.errors["tracking_url"] = ["Campo requerido"];
      }

      return Object.keys(this.errors).length === 0;
    },

    async send() {
      if (!this.validateForm()) {
        this.$store.dispatch(
          "errorSnack",
          "Favor de llenar todos los campos correctamente."
        );
        return;
      }

      this.loadingSend = true;

      try {
        const response = await api.productOrders.send(this.order.id, this.form);
        this.$store.dispatch("successSnack", response.message);
        this.loadProductOrder();
      } catch (error) {
        if (is422(error)) {
          this.errors = error.response && error.response.data.errors;
        }
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingSend = false;
    },
  },
};
</script>